import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root'
})
export class VendorGroupsProductsService {

  constructor(
      private restangular: ApiClient
  ) { }

  getAllVendorGroupProducts(limit = 10000, offset = 0, search = ''): Promise<any> {
    return this.restangular.one(`/vendors/groups/products?limit=${limit}&offset=${offset}&search=${search}`).get().toPromise();
  }

  createVendorGroupProduct(vendorProductIds: Array<string>, metadata: any): Promise<any> {
    return this.restangular.one('/vendors/groups/products').customPOST({
      vendorProductIds, metadata,
    }).toPromise();
  }

  modifyVendorGroupProduct(id: string, fields: any): Promise<any> {
    return this.restangular.one('/vendors/groups/products', id).customPUT({
      ...fields
    }).toPromise();
  }

  deleteVendorGroupProduct(id: string): Promise<any> {
    return this.restangular.one('vendors/groups/products', id).remove().toPromise();
  }

}
